// extracted by mini-css-extract-plugin
module.exports = {"canvasContainer":"IrisCanvas_canvasContainer__6UhLy"};